import { axios } from 'src/api'
import {
  ApiGetOfferDataParams,
  ApiGetOfferDataResponse
} from './getofferdata.types'

export const ApiGetOfferData = async ({
  serverPath,
  data,
  controller
}: ApiGetOfferDataParams) => {
  return await axios.post<ApiGetOfferDataResponse>(
    `https://${serverPath}/sialdPMS/web/resourcescrossorigin/seasonmanual/getofferdata`,
    data, {
      signal: controller?.signal
    }
  )
}
